'use client'
import { createCn, isNullable } from 'shared-utils'
import { GrandProse, GrandSection, ParsedHtml } from 'ui'
import type { FC } from 'react'
import type { ContentBoxWidgetType, StorefrontWidget } from 'ecosystem'
import { type WidgetImplementation } from '../registry/typings'

const cn = createCn('content-box')

const WIDGET_CN = {
  SECTION: cn('article'),
  SECTION_CONTAINER: cn('section-container'),
  CONTENT: cn('content')
}

type ContextBoxProps = WidgetImplementation<StorefrontWidget<ContentBoxWidgetType>>

const ContentBox: FC<ContextBoxProps> = ({
  widgetId,
  widget: {
    widget: { content, isWrapped }
  }
}) => {
  const hasCustomStyles = content?.includes('<style')

  const renderContent = () => (
    <GrandProse
      as="article"
      className={WIDGET_CN.CONTENT}
      w="100%"
      fontSize="md"
      rawStyles={hasCustomStyles}
    >
      <ParsedHtml html={content || ''} />
    </GrandProse>
  )

  // if widget was created before implementing isWrapped the value = undefined and component was intended to be wrapped
  if (!isNullable(isWrapped) && !isWrapped) {
    return renderContent()
  }

  return (
    <GrandSection
      className={WIDGET_CN.SECTION}
      contentContainerProps={{
        className: WIDGET_CN.SECTION_CONTAINER
      }}
      sectionId={widgetId}
    >
      {renderContent()}
    </GrandSection>
  )
}

export default ContentBox
